import React from 'react'
import '.././component.css'

const Component5 = () => {
  return (
    <div>Component5</div>
  )
}

export default Component5